import { render, staticRenderFns } from "./ConversationNavigationButtonsBlock.vue?vue&type=template&id=68cae795&"
import script from "./ConversationNavigationButtonsBlock.vue?vue&type=script&lang=js&"
export * from "./ConversationNavigationButtonsBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports